import React from "react";
import MyVoucher from "./MyVoucher";

export default function VoucherList() {
    return (
        <div
            className="MuiGrid-root styles_promoContent_wrap__hmZtc MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
            style={{ padding: "10px 8px", backgroundColor: "rgb(244, 247, 252)" }}
        >
            <div className="MuiGrid-root styles_promoTitle__Nprix">
                <p className="MuiTypography-root MuiTypography-body1">
                    Danh sách mã giảm giá
                </p>
            </div>

            <MyVoucher />
        </div>
    );
}
